import { createContext, useContext, useState, useEffect } from 'react';

type DeviceContextType = {
  isMobile: boolean;
};

type DeviceProviderProps = {
  children: React.ReactNode;
};

// Default to desktop
const DeviceContext = createContext<DeviceContextType>({ isMobile: false });

const MOBILE_BREAKPOINT = 768; // Standard mobile breakpoint

export function DeviceProvider({ children }: DeviceProviderProps) {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    // Check on mount
    checkDevice();

    // Add resize listener
    window.addEventListener('resize', checkDevice);

    // Cleanup
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return (
    <DeviceContext.Provider value={{ isMobile }}>
      {children}
    </DeviceContext.Provider>
  );
}

export const useDevice = () => useContext(DeviceContext); 